import { Urls } from '../../constants/Urls';

import { createHelpUrl, getCurrentPathnameFromState, getSubscriptionPath } from './shared';

export function isOnPlansPage(state) {
  const currentPath = getCurrentPathnameFromState(state);
  return currentPath === '/plans';
}

export function getFamilyPlanManagementPath() {
  return '/family/invite';
}

export function getFamilyPlanInviteeLandingPath() {
  return '/family/accept';
}

export function getPartnerUpgradePath() {
  return '/subscription/activate';
}

export function isPartnerUpgradePath(path) {
  return /subscription\/activate.*/.test(path);
}

export function getAttPremiumPath() {
  return '/subscription/premium-att';
}

export function isAttPremiumPath(path) {
  return /subscription\/premium-att.*/.test(path);
}

export function isOfferPath(path) {
  return path.includes('/offer');
}

export function isOnSubscriptionPage(state) {
  const path = getCurrentPathnameFromState(state);
  return path && path.includes && path.includes(getSubscriptionPath());
}

export function getPremiumMicrositePath() {
  return '/premium';
}

export function getPremiumInvitePath() {
  return '/premium/invite';
}

export function getPremiumWelcomePath() {
  return '/premium/welcome';
}

export function getPlusUpgradePath() {
  return '/upgrade/plus';
}

export function getPremiumUpgradePath() {
  return '/upgrade/premium';
}

export function getFamilyPlanUpgradePath() {
  return '/upgrade/premium/family-plan';
}

export function getPremiumMilitaryPlanUpgradePath() {
  return '/upgrade/premium/military';
}

export function getPremiumStudentPlanUpgradePath() {
  return '/upgrade/premium/student';
}

export function getUpgradeLandingPath() {
  return '/upgrade';
}

export function getPlansPath() {
  return '/plans';
}

export function getTermsUrl() {
  return `${Urls.SUBSCRIPTION_TERMS}`;
}

export function getTrialOffersTermsUrl() {
  return `${Urls.TRIAL_OFFERS_TERMS}`;
}

export function getChangePaymentHelpUrl() {
  return createHelpUrl('/s/article/Change-your-Payment-Information-1519949295577');
}

export function getContactSupportUrl() {
  return createHelpUrl('/s/contactsupport');
}

export function getCancelVBSHelpUrl() {
  return createHelpUrl('/s/article/Cancel-your-Subscription-1519949295562');
}

export function getUpgradePath(tierSlug, subTierSlug) {
  if (tierSlug && subTierSlug) {
    return `/upgrade/${tierSlug}/${subTierSlug}`;
  } else if (tierSlug) {
    return `/upgrade/${tierSlug}`;
  }

  return '/upgrade';
}

export function isFamilyPlanPath(path) {
  return /^\/family(\/(manage|accept|invite))?$/.test(path);
}

export function isUpgradeOrSettingsUpgradePage(path) {
  return path && path.includes && path.includes(getUpgradePath());
}

export function isOnUpgradePage(state) {
  const currentPath = getCurrentPathnameFromState(state);
  return isUpgradeOrSettingsUpgradePage(currentPath);
}

export function isPaymentPath(path) {
  return /^\/payment(.*)$/.test(path);
}

export function isOnPaymentsPage(state) {
  const currentPath = getCurrentPathnameFromState(state);
  return isPaymentPath(currentPath);
}

export function isOnUpgradeOrPaymentsPage(state) {
  return isOnUpgradePage(state) || isOnPaymentsPage(state);
}

// TODO: Temp solution, remove get(.*)PaymentPath in WEBCLIENT-7008
export function getPlusPaymentPath() {
  return '/payment/plus';
}

export function getPremiumPaymentPath() {
  return '/payment/premium';
}

export function getFamilyPlanPaymentPath() {
  return '/payment/premium/family-plan';
}

export function getPremiumMilitaryPlanPaymentPath() {
  return '/payment/premium/military';
}

export function getPremiumStudentPlanPaymentPath() {
  return '/payment/premium/student';
}

export function getPremiumStudentPlanVerificationPath() {
  return '/verify/premium/student';
}

export function getPremiumMilitaryPlanVerificationPath() {
  return '/verify/premium/military';
}

export function isUpgradeLandingPath(state) {
  const currentPath = getCurrentPathnameFromState(state);
  return currentPath === getUpgradeLandingPath();
}

export function getStudentTermsUrl() {
  return `${Urls.STUDENT_TERMS}`;
}

export function getMilitaryTermsUrl() {
  return `${Urls.MILITARY_TERMS}`;
}

export function getPaymentPath(tierSlug, subTierSlug) {
  if (tierSlug && subTierSlug) {
    return `/payment/${tierSlug}/${subTierSlug}`;
  } else if (tierSlug) {
    return `/payment/${tierSlug}`;
  }
  return '';
}

export function getDiscountVerificationPath(tierSlug, verificationType) {
  if (tierSlug && verificationType) {
    return `/verify/${tierSlug}/${verificationType}`;
  }
  return '';
}

export function isOnVerificationPage(state) {
  const currentPath = getCurrentPathnameFromState(state);
  return /^\/verify(.*)$/.test(currentPath);
}

export function getDeepLinkAccountBilling() {
  return 'pandorav5://account/billing';
}

export function getAccountBillingUniversalLinkPathname() {
  return '/account/billing';
}

export function getCongratulationsPath() {
  return '/settings/redeem/congratulations';
}

export function getStudentReverificationCongratulationsPath() {
  return '/verify/premium/student/congratulations';
}

export function getCancelUrl() {
  return Urls.CANCEL;
}
